export default __webpack_public_path__ + "static/media/logo2.29f35552.png";